import {
    runVdrBulkUploadWithTray,
    VDR_UPLOAD_BATCH_SIZE,
    VDR_UPLOAD_MAX_FILES,
    validateVdrUploadFileCount,
    extractUploadErrorMessage,
} from './vdrBulkUpload';

export { VDR_UPLOAD_BATCH_SIZE, VDR_UPLOAD_MAX_FILES, validateVdrUploadFileCount, extractUploadErrorMessage };

/**
 * Multi-file upload into one folder — batched bulk_folder_upload (50 per request).
 */
export async function uploadFilesWithProgressTray({
    dispatch,
    files,
    folder,
    workstreamId,
    projectId,
    vdrId,
    uploadBy,
}) {
    return runVdrBulkUploadWithTray({
        dispatch,
        files,
        folder,
        workstreamId,
        projectId,
        vdrId,
        uploadBy,
        flatIntoFolder: true,
        destinationLabel: folder?.name || '',
        refreshWorkstreamList: true,
    });
}

/**
 * Folder tree upload — same batched bulk path; runs in background from the modal.
 */
export function uploadFolderWithProgressTray({
    dispatch,
    files,
    folder,
    workstreamId,
    projectId,
    vdrId,
    uploadBy,
    destinationLabel,
}) {
    const promise = runVdrBulkUploadWithTray({
        dispatch,
        files,
        folder,
        workstreamId,
        projectId,
        vdrId,
        uploadBy,
        flatIntoFolder: false,
        destinationLabel,
        refreshWorkstreamList: true,
    });

    promise.then(result => {
        if (!result?.started && result?.message) {
            // eslint-disable-next-line no-console
            console.warn('[VDR folder upload]', result.message);
        }
    });

    return { started: true, promise };
}
